import { KpiFormat } from './types';

export const formatKpiValue = (value: number, format: KpiFormat): string => {
    switch (format) {
        case 'currency':
            return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD', useGrouping: false }).format(value);
        case 'percentage':
            return `${new Intl.NumberFormat(undefined, { maximumFractionDigits: 1, useGrouping: false }).format(value)}%`;
        case 'duration':
            return `${new Intl.NumberFormat(undefined, { maximumFractionDigits: 1, useGrouping: false }).format(value)} hrs`;
        case 'decimal':
            return new Intl.NumberFormat(undefined, { minimumFractionDigits: Number.isInteger(value) ? 1 : 0, maximumFractionDigits: 2, useGrouping: false }).format(value);
        default:
            return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0, useGrouping: false }).format(value);
    }
};
